import { LetterStatus } from '../helpers'

export function generateShareText(
  board: string[][],
  boardStatus: LetterStatus[][],
  attempts: number,
  won: boolean
): string {
  const currentDate = new Date().toLocaleDateString('en-CA') // YYYY-MM-DD format
  
  // Generate attempt count in X/6 format
  const attemptCount = won ? `${attempts}/6` : 'X/6'
  
  // Generate the header
  let shareText = `Woordel 🌶️ ${currentDate} ${attemptCount}\n\n`
  
  // Generate emoji grid for completed attempts
  for (let i = 0; i < attempts; i++) {
    let row = ''
    for (let j = 0; j < 5; j++) {
      const status = boardStatus[i][j]
      switch (status) {
        case LetterStatus.LetterAndPosition:
          row += '🟩' // Green square for correct position
          break
        case LetterStatus.Letter:
          row += '🟨' // Yellow square for correct letter, wrong position
          break
        default:
          row += '⬛' // Black square for incorrect letter
          break
      }
    }
    shareText += row + '\n'
  }
  
  return shareText.trim()
}

export function isMobileDevice(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export async function shareContent(text: string): Promise<void> {
  if (isMobileDevice() && navigator.share) {
    try {
      await navigator.share({
        text: text
      })
    } catch (error) {
      // If sharing fails, fall back to clipboard
      await copyToClipboard(text)
    }
  } else {
    await copyToClipboard(text)
  }
}

export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text)
  } catch (error) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    document.execCommand('copy')
    textArea.remove()
  }
}